import useCancelReturnRequest from "@babackapp/private-api-client/client/use-cancel-return-request";
import useTranslation from "@babackapp/translations/use-translation";
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
} from "@babackapp/ui/components/alert-dialog";
import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import { useCurrentReturnRequest } from "../../../utils/current-return-request-context";

interface CancelReturnAlertDialogProps {
	isOpen: boolean;
	onOpenChange: (isOpen: boolean) => void;
}

export default function CancelReturnAlertDialog({
	isOpen,
	onOpenChange,
}: CancelReturnAlertDialogProps) {
	const { data: shop } = useCurrentShopSuspense();
	const returnRequest = useCurrentReturnRequest();
	const t = useTranslation();
	const { mutate } = useCancelReturnRequest();

	const handleCancelReturn = () => {
		mutate({
			returnRequestId: returnRequest.id,
			shopId: shop.id,
		});
	};

	return (
		<AlertDialog open={isOpen} onOpenChange={onOpenChange}>
			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle>
						{t("returnDetail.cancelReturnRequestTitle")}
					</AlertDialogTitle>
					<AlertDialogDescription>
						{t("returnDetail.cancelReturnRequest")}
					</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter>
					<AlertDialogCancel>{t("misc.cancel")}</AlertDialogCancel>
					<AlertDialogAction onClick={handleCancelReturn}>
						{t("misc.continue")}
					</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	);
}
